import {
    Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild
} from '@angular/core';
import {SolrEntityService, EntityTreeService} from "@signature-it/ngx-entity/services";
import {SolrEntity, SolrOptionsEntityDTO} from "@signature-it/ngx-entity/models";
import {ActivatedRoute} from "@angular/router";
// import {TreeComponent, TreeNode} from "@circlon/angular-tree-component";
import {Observable} from "rxjs";
import { LanguageService} from "@signature-it/ngx-generic/services";
import {GenericConfig} from "@signature-it/ngx-generic/config";
import {EntityTreeData} from "@signature-it/ngx-entity/types";

@Component({
    selector: 'entity-taxonomy',
    templateUrl: './entity-taxonomy.component.html',
    styleUrls: ['./entity-taxonomy.component.scss'],
    standalone: false
})
export class EntityTaxonomyComponentGeneric implements OnInit{
    @Input() taxonomyTypeVar: string;
    @Input() relatedEntityTypeVar: string;
    @Input() treeNodeVar: string;
    @Input() key: string;
    @Input() additionalFQ = [];
    @Input() customElementAdditionalFq: string;
    @Output() selectItem: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('treeCmp', {static: false}) protected treeCmp;
    entityTreeData: EntityTreeData;
    tree = {
        loading: false,
        options: {
            rtl: false
        },
        nodes:  []
    };
    baseTree;
    currLang;
    currentNodeId;
    ngxTreeConfig;

    constructor(protected solrEntityService: SolrEntityService,
                protected entityService: EntityTreeService,
                protected activatedRoute: ActivatedRoute,
                public langSvc:LanguageService,
                private ngZone: NgZone) {}


    ngOnInit() {
        if(Array.isArray(GenericConfig.ngxTreeConfig) && this.key) {
            this.ngxTreeConfig = GenericConfig.ngxTreeConfig.find(item => item.key == this.key);
        }

        this.entityService.getTree(this.taxonomyTypeVar,  this.treeNodeVar).subscribe(
            res => {
                this.getRelatedEntityVar().subscribe(
                    entityTypeVar => {
                            this.relatedEntityTypeVar = entityTypeVar;
                            this.initTree(res);
                    }
                )
            },
            error => {

            }
        )

        // RTL
        this.langSvc
            .getCurrentLanguage$()
            .subscribe(lang => {
                this.currLang = lang;
                this.tree.options.rtl = this.langSvc.isRTL( lang );
            });


        if(this.customElementAdditionalFq){
            this.additionalFQ = JSON.parse(this.customElementAdditionalFq);
        }

    }

    getRelatedEntityVar(): Observable<any> {
        return new Observable((observer) => {
                if(this.relatedEntityTypeVar) {
                    observer.next(this.relatedEntityTypeVar);
                } else {
                    this.entityService.getEntityTypeRelated(this.taxonomyTypeVar).subscribe(
                        res => {
                            observer.next(res);
                        },
                        error => {

                        }
                    )
                }
            }
        )
    }

    initTree(data) {
        this.baseTree = data;
        const solrOptions = new SolrOptionsEntityDTO({
            isGroupBy: true,
            groupField: 'node_id_i',
            isFacet: true,
            entityTypeVar: this.relatedEntityTypeVar,
            additionalFQ: this.additionalFQ,
        });
        this.solrEntityService.getSolr(solrOptions).subscribe(
            solrResponse => {
                    const tree = this.baseTree.slice();
                    this.getRecursiveName(tree, solrResponse.facet_counts.facet_fields.node_id_is);
                    this.tree.nodes = tree;
                    if(!this.ngxTreeConfig.showTree){
                        this.loadFirstNode();
                    }
            }
        );
    }

    divideDocsToArrays(docs: Array<SolrEntity>): any {
        const entityTreeData = {};
        docs.forEach(doc => {
            if(!entityTreeData[doc.nodeId]) {
                entityTreeData[doc.nodeId] = {
                    title:  doc['nodeName'],
                    children: []
                };
            }
            entityTreeData[doc.nodeId].children.push(doc);
        })
        return this.sortEntityTreeData(entityTreeData);
    }

    sortEntityTreeData(entityTreeData) {
        let currentNode = this.getCurrentNode(this.tree.nodes);
        if (currentNode && currentNode['children'] && currentNode['children'].length) {
            let idsArray = currentNode['children'].map(child => child.id);
            let sortEntityTreeData = {};
            idsArray.forEach(id => {
                sortEntityTreeData['"' + id + '"'] = entityTreeData[id];
            });
            entityTreeData = sortEntityTreeData;
        }
        return entityTreeData;
    }

    getCurrentNode(nodes) {
        if(nodes) {
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].id == this.currentNodeId) {
                    return nodes[i];
                }
                return this.getCurrentNode(nodes[i].children);
            }
        }
    }

    // loadNode(node: TreeNode, node_id =  null) {
    loadNode(node, node_id =  null) {
        // const nodeId = node_id || (this.showSiblings(node) ? node.data.parent : node.data.id);
        // if(nodeId !== this.currentNodeId) {
        //     this.currentNodeId = nodeId;
        //     const solrOptions = new SolrOptionsEntityDTO({
        //         entityTypeVar: this.relatedEntityTypeVar,
        //         parentNodeId: this.currentNodeId,
        //         additionalFQ: this.additionalFQ,
        //         sort: 'order_i+asc',
        //         itemsPerPage: 1000000,
        //     });
        //     this.solrEntityService.getSolr(solrOptions).subscribe(
        //         solrResponse => {
        //             this.entityTreeData = this.divideDocsToArrays(SolrEntity.createFromArray(solrResponse['response']['docs']));
        //             this.scrollToSection(node.data.id);
        //         }
        //     );
        // } else {
        //     this.scrollToSection(node.data.id);
        // }
    }

    // showSiblings(node : TreeNode) {
    showSiblings(node) {
        // return this.ngxTreeConfig.show_related_node && node.isLeaf && node.data.parent != 0;
    }

    scrollToSection(nodeId) {
        const el: HTMLElement|null = document.getElementById('tree-section' + nodeId);
        if (el) {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() =>
                    el.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'}), 0);
            })
        }

    }

    getRecursiveName(tree, facetsData) {
        if(tree.hasOwnProperty('id')) {
            tree = tree.children;
        }
        for(let i = 0; i < tree.length; i++) {
            let found = false;
            if(tree[i]['id']) {
                if(facetsData.length > 0) {;
                    found = facetsData.find(item => item[0] == tree[i]['id']);
                    if(found) {
                        tree[i]['count'] = found[1];
                        if(tree[i]['id'] == this.currentNodeId) {
                            tree[i]['active'] = true;
                        }
                    }
                }
            }
            if(tree[i] && tree[i]['children'] && tree[i]['children'].length) {
                this.getRecursiveName(tree[i]['children'], facetsData)
            }
            if(!found) {
                tree.splice(i, 1);
                i--;
            }
            if(tree.length == i+1) {
                // this.orderPipe.transform(tree, 'count', true);
            }
        }
    }

    initializedTree() {
        let someNode;
        someNode = this.treeCmp.treeModel.roots[0];
        someNode.expand();
        someNode.setActiveAndVisible();
        this.loadNode(someNode);
    }

    itemSelect(entity_var) {
        this.selectItem.next(entity_var);
    }

    returnZero() {
        return 0;
    }

    loadFirstNode() {
        this.loadNode(null, this.tree.nodes[0]['id']);
    }
}
